import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchUnits({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/units`, { params })
    .then(res => (res.data))
    .then(units => dispatch('setUnits', units))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching units:', err);
      return Promise.reject(err);
    });
}

export function fetchCoreConcepts({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/core-concepts`, { params })
    .then(res => (res.data))
    .then(coreConcepts => dispatch('setCoreConcepts', coreConcepts))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching core concepts:', err);
      return Promise.reject(err);
    });
}

export function fetchDomains({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/domains`, { params })
    .then(res => (res.data))
    .then(domains => dispatch('setDomains', domains))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching domains:', err);
      return Promise.reject(err);
    });
}

export function setMyCardsFilter({ commit }, filterInfo) {
  commit(types.SET_MY_CARDS_FILTER, filterInfo);

  return Promise.resolve();
}

export function setLibrartFilter({ commit }, filterInfo) {
  commit(types.SET_LIBRARY_FILTER, filterInfo);

  return Promise.resolve();
}

export function setPageLibraryFilter({ commit }, filterInfo) {
  commit(types.SET_PAGE_LIBRARY_FILTER, filterInfo);

  return Promise.resolve();
}

export function setAssignmentsFilter({ commit }, filterInfo) {
  commit(types.SET_ASSIGNMENTS_FILTER, filterInfo);

  return Promise.resolve();
}

export function setCoreConcepts({ commit }, coreConcepts) {
  commit(types.SET_CORE_CONCEPTS, coreConcepts);

  return Promise.resolve(coreConcepts);
}

export function setDomains({ commit }, domains) {
  commit(types.SET_DOMAINS, domains);

  return Promise.resolve(domains);
}

export function setUnits({ commit }, units) {
  commit(types.SET_UNITS, units);

  return Promise.resolve(units);
}

export function fetchGrades({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/grades`)
    .then(res => dispatch('setGrades', res.data))
    .catch(err => Promise.reject(err));
}

export function setGrades({ commit }, grades) {
  commit(types.SET_GRADES, grades);

  return Promise.resolve(grades);
}


export function fetchSubjects({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/subjects`)
    .then(res => dispatch('setSubjects', res.data))
    .catch(err => Promise.reject(err));
}

export function setSubjects({ commit }, subjects) {
  commit(types.SET_SUBJECTS, subjects);

  return Promise.resolve(subjects);
}

export function fetchSubjectGrades({ commit }, params) {
  return http.get(`${MINERVA_API_URL}/subject_grades`, { params })
    .then(res => commit(types.SET_SUBJECT_GRADES, res.data))
    .catch(err => Promise.reject(err));
}
